<qrcode [qrdata]="updatedData" [width]="256" id="qrCodeElement"></qrcode>

<button (click)="printQRCode()">{{ 'PrintQRCode' | translate }}</button>
